/** Значения `App\Enums\UserStatusEnum` на бэкенде. */
export const USER_STATUS_VALUES = ['looking_project', 'open_to_offers', 'busy'] as const

export type UserStatusValue = (typeof USER_STATUS_VALUES)[number]

export const USER_STATUS_OPTIONS: { label: string; value: UserStatusValue }[] = [
  { value: 'looking_project', label: 'Ищу проект' },
  { value: 'open_to_offers', label: 'Открыт к предложениям' },
  { value: 'busy', label: 'Занят' },
]

export const DEFAULT_USER_STATUS: UserStatusValue = 'looking_project'

export const isUserStatusValue = (s: string | undefined | null): s is UserStatusValue =>
  s != null && (USER_STATUS_VALUES as readonly string[]).includes(s)
